import React from 'react';
import cx from 'classnames';
import cs from './index.module.scss';

const EyeShowIcon: React.FC<any> = ({ className, ...restProps }) => (
  <span className={cx(cs.container, className)} {...restProps}>
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect opacity="0.01" width="20.3782" height="19.3835" fill="#1E2329" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.10059 11.177C4.46659 14.6819 7.1648 16.4761 10.1892 16.4761C13.2136 16.4761 15.9119 14.6819 18.2779 11.177C18.4908 10.8621 18.4908 10.4599 18.2779 10.145C15.9119 6.64009 13.2136 4.84595 10.1892 4.84595C7.1648 4.84595 4.46659 6.64009 2.10059 10.145C1.8877 10.4599 1.8877 10.8621 2.10059 11.177ZM3.2275 10.661C5.36668 7.5327 7.68547 6.00896 10.1892 6.00896C12.693 6.00896 15.0118 7.5327 17.1509 10.661C15.0118 13.7893 12.693 15.313 10.1892 15.313C7.68547 15.313 5.36668 13.7893 3.2275 10.661ZM10.1892 13.3747C8.58061 13.3747 7.27656 12.1597 7.27656 10.661C7.27656 9.16227 8.58061 7.94731 10.1892 7.94731C11.7978 7.94731 13.1019 9.16227 13.1019 10.661C13.1019 12.1597 11.7978 13.3747 10.1892 13.3747ZM11.8537 10.661C11.8537 11.5174 11.1085 12.2117 10.1892 12.2117C9.26996 12.2117 8.52473 11.5174 8.52473 10.661C8.52473 9.80464 9.26996 9.11032 10.1892 9.11032C11.1085 9.11032 11.8537 9.80464 11.8537 10.661Z"
        fill="#707A8A"
      />
    </svg>
  </span>
);

export default EyeShowIcon;
